import React from "react";
import Layout from "../../components/layout/Layout";
import PageHeader from "../../components/layout/PageHeader";
import NotificationCenter from "../../components/notifications/NotificationCenter";
import "../admin/admin.css";

/** /notifications: the large notifications view as a page (HR view). */
const NotificationsPage = () => (
  <Layout>
    <div className="container-fluid py-4 px-lg-4">
      <PageHeader
        title="Notifications"
        subtitle="Everything sent to you: approvals, results and HR alerts."
      />
      <div className="admin-card">
        <NotificationCenter />
      </div>
    </div>
  </Layout>
);

export default NotificationsPage;
